module.exports = __webpack_public_path__ + "static/media/checkbox-checked-icon.91af72b9.svg";